import { Sprite } from '@pixi/sprite';

import { LocalisedTextAnimated } from '../LocalisedTextAnimated';
import { NineSliceButton } from './NineSliceButton';

const defaultOptions = {
    text: '',
    fontSize: 48,
    width: 400,
    height: 180,
};

export type PerkButtonOptions = typeof defaultOptions;

export class PerkButton extends NineSliceButton
{
    
    constructor(opts: Partial<PerkButtonOptions> = {})
    {
        const o = { ...defaultOptions, ...opts };
        const bonusIcon = new Sprite();

        const bonusText = new LocalisedTextAnimated(o.text, {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            stroke: 0x333333,
            strokeThickness: o.fontSize / 5,
            lineJoin: 'round',
            align: 'center',
            fontSize: o.fontSize,
            maxWidth: o.width - 100,
        });

        bonusText.anchor.set(0.5);
        bonusIcon.addChild(bonusText);

        super({
            icon: bonusIcon,
            bgAsset: 'button-ninesliced-perk',
            w: o.width,
            h: o.height,
            startHidden: true,
        });
    }
}
